var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-jumbotron',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(_vm._s(_vm.$t('common.no_data')))]},proxy:true}])},[_c('hr',{staticClass:"my-4"}),_c('p',[_vm._v(" "+_vm._s(_vm.$t('error.datatable_retrieve_error_short'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }